import React from "react";
import InputGroup from "../components/inputGroup/InputGroup";
import themeStyles from "../../shared/styles/theme/theme-styles.module.scss";
import styles from "./styles.module.scss";
import SearchBC from "../components/bowlingCenterSearch/searchBC";

const LiveScoringForm = (props) => {
  const {
    data,
    bowlingCentersList,
    errors,
    setupType,
    handleChange,
    handleSubmit,
    saveData,
    clearForm,
  } = props;

  const typeLane = setupType === "By Lane";

  return (
    <form>
      <div className={styles.liveScoringForm}>
        <div className={styles.scoringHeader}>
          <div className={styles.columnIndex}>{""}</div>
          <div className={styles.columnPlayer}>{"Bowling Center Name"}</div>
          <div className={styles.columnLane}>{"Lane"}</div>
          {setupType === "By Lane" && (
            <div className={styles.columnLane}>{"Number of Players"}</div>
          )}
          {setupType !== "By Lane" && (
            <div className={styles.columnNumber}>{"Player Number"}</div>
          )}
          <div className={styles.columnPlayer}>{"Player"}</div>
          <div className={styles.columnPlayer}>{"Display Name"}</div>
          <div className={styles.columnNumber}>{"Group"}</div>
        </div>
        <div className={styles.line}></div>
        {data.map((bowling, index) => (
          <div className={styles.scoringItem} key={index}>
            <div className={styles.columnIndex}>{index + 1 || ""}</div>
            <div className={styles.columnPlayer}>
              <SearchBC
                handleChange={handleChange}
                index={index}
                bowlingCenterInput={bowling}
                bowlingCentersList={bowlingCentersList}
              />
            </div>
            <div className={styles.columnLane}>
              <InputGroup
                name={`lane-${index}`}
                leftMargin={false}
                inputValue={bowling && bowling.lane}
                inputType="number"
                onChange={handleChange(index, "lane")}
              />
            </div>
            <div className={styles.columnNumber}>
              <InputGroup
                name={`playerNumber`}
                leftMargin={false}
                inputType="number"
                inputValue={bowling && bowling.playerNumber}
                onChange={handleChange(index, "playerNumber")}
              />
            </div>
            <div className={styles.columnPlayer}>
              <InputGroup
                name={`player-${index}`}
                leftMargin={false}
                inputValue={bowling && bowling.player}
                onChange={handleChange(index, "player")}
                disabled={typeLane}
              />
            </div>
            <div className={styles.columnPlayer}>
              <InputGroup
                name={`displayName-${index}`}
                leftMargin={false}
                inputValue={bowling && bowling.displayName}
                onChange={handleChange(index, "displayName")}
                disabled={typeLane}
              />
            </div>
            <div className={styles.columnNumber}>
              <InputGroup
                name={`group-${index}`}
                leftMargin={false}
                inputValue={bowling && bowling.group}
                inputType="number"
                onChange={handleChange(index, "group")}
                disabled={typeLane}
              />
            </div>
          </div>
        ))}
      </div>
      {errors && <p className={styles.textError}>{errors}</p>}
      <div className={styles.buttonRow}>
        <button className={`${themeStyles.btnPrimary}`} onClick={handleSubmit}>
          View Live Scoring
        </button>
        <button
          type="button"
          className={`${themeStyles.btnPrimary}`}
          onClick={saveData}
        >
          Save Data
        </button>
        <button
          type="button"
          className={`${themeStyles.btnPrimary}`}
          onClick={clearForm}
        >
          Clear Form
        </button>
      </div>
    </form>
  );
};
export default LiveScoringForm;
